/**
 * Board Card Review Details Handler
 *
 * Collapsible "Review Details" section on list-style (list_style=LIST) board cards.
 * Same expand/collapse-then-hide technique as post/shared/back-number-toggle-handler.ts.
 */

import { BoardCardReviewDetailsForm } from "./board-card-review-details-form";
import {
    bindBoardCardReviewDetailsClick,
    bindBoardCardReviewDetailsTransitionEnd,
    unbindBoardCardReviewDetailsTransitionEnd,
} from "./board-card-review-details-listener";

const COLLAPSE_CLASS = "is-collapsed";

class BoardCardReviewDetailsHandler {
    public static init(root: ParentNode | null): void {
        const domRoot = root || document;

        const toggle = BoardCardReviewDetailsForm.getToggle(domRoot);
        const body = BoardCardReviewDetailsForm.getBody(domRoot);
        if (!toggle || !body) return;

        if (toggle.dataset.reviewDetailsInit === "1") return;
        toggle.dataset.reviewDetailsInit = "1";

        const expand = (): void => {
            body.hidden = false;
            requestAnimationFrame(() => {
                body.classList.remove(COLLAPSE_CLASS);
            });
            toggle.setAttribute("aria-expanded", "true");
        };

        const collapse = (): void => {
            body.classList.add(COLLAPSE_CLASS);
            toggle.setAttribute("aria-expanded", "false");

            const onTransitionEnd = (event: TransitionEvent): void => {
                if (event.propertyName !== "max-height") return;
                unbindBoardCardReviewDetailsTransitionEnd(body, onTransitionEnd);
                body.hidden = true;
            };

            bindBoardCardReviewDetailsTransitionEnd(body, onTransitionEnd);
        };

        bindBoardCardReviewDetailsClick(toggle, () => {
            if (body.classList.contains(COLLAPSE_CLASS)) {
                expand();
                return;
            }

            collapse();
        });
    }
}

export { BoardCardReviewDetailsHandler };
